import { createApp } from 'vue'
import router from '@/routers/router'

import { css, HEX } from '@/services/create_css';
import { carousel } from '@/services/carousel';
import { href_APP } from '@/services/useful';

import "@/assets/css/css.css";
import "@/assets/css/resp.css";

import App from '@/layouts/index.vue'

    // FORÇA META VIEWPORT
        let metaViewport = document.querySelector('meta[name="viewport"]');
        if (metaViewport) {
            metaViewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no');
        } else {
            metaViewport = document.createElement('meta');
            metaViewport.name = 'viewport';
            metaViewport.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no';
            document.head.appendChild(metaViewport);
        }
    // FORÇA META VIEWPORT

    // APP
        const app = createApp(App);

        app.mixin({
            data: function() {
                return {
                    'HEX_1': $_GLOBAL.HEX_1,
                    'HEX_2': $_GLOBAL.HEX_2,
                    'HEX_3': $_GLOBAL.HEX_3,
                    'HEX_4': $_GLOBAL.HEX_4,
                    'HEX_5': $_GLOBAL.HEX_5,
                }
            },
        })

        app.use(router);

        app.mount('#app');

        app.mixin({
            updated: function() {
                css();
                href_APP();
                setTimeout(() => { carousel(); }, .5);
            },
        })
    // APP

    HEX();
